import $ from 'jquery'

/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export function getAllFiles (formId) {
  const selector = '#gform_uploaded_files_' + formId
  const $uploadedFiles = $(selector)
  let files = $uploadedFiles.val()
  files = (typeof files === 'undefined') || files === '' ? {} : $.parseJSON(files)

  return files
}
